import Router from "./navigation/Router";

function App() {
  return <Router />;
}

export default App;
